module.exports = __webpack_public_path__ + "static/media/01d.a5a472c2.svg";